/**
 * Copyright © 2026 Adnuntius AS.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {ButtonsModule} from 'ngx-bootstrap/buttons';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';

import {AppSharedModule} from '../common/app-shared.module';
import {AdminResourcePagesModule} from '../common/controller/admin-resource-pages.module';
import {AdnSelectComponent} from '../common/directives/adn-select/adn-select.component';
import {CodemirrorFieldComponent} from '../common/directives/codemirror-field.component';
import {FormControlsModule} from '../common/directives/form-controls/form-controls.module';
import {GridsterWorkspaceComponent} from '../common/directives/gridster-workspace.component';
import {LineItemLabelsModule} from '../line-item/line-item-labels.module';
import {WorkspaceEditPageComponent} from './workspace-edit-page.component';
import {WorkspaceEditWorkspaceComponent} from './workspace-edit-workspace.component';
import {WorkspaceGridsterItemEditComponent, WorkspaceGridsterItemViewComponent} from './workspace-gridster-item.component';
import {WorkspaceListPageComponent} from './workspace-list-page.component';
import {WorkspaceRoutePageComponent} from './workspace-route-page.component';
import {WorkspaceViewPageComponent} from './workspace-view-page.component';
import {WorkspaceWidgetsModule} from './workspace-widgets.module';

const WORKSPACE_PAGES = [
  WorkspaceEditPageComponent,
  WorkspaceEditWorkspaceComponent,
  WorkspaceGridsterItemEditComponent,
  WorkspaceGridsterItemViewComponent,
  WorkspaceListPageComponent,
  WorkspaceRoutePageComponent,
  WorkspaceViewPageComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    FormsModule,
    TranslateModule,
    UIRouterModule,
    ButtonsModule,
    BsDatepickerModule,
    AdminResourcePagesModule,
    AdnSelectComponent,
    CodemirrorFieldComponent,
    FormControlsModule,
    GridsterWorkspaceComponent,
    LineItemLabelsModule,
    WorkspaceWidgetsModule
  ],
  declarations: WORKSPACE_PAGES,
  exports: WORKSPACE_PAGES
})
export class WorkspaceModule {
}
